import {textSizes} from '@stencil/build-theme';
import styled from 'styled-components';

const likeAStarPaddingCalc = props => {
  if (props.isMweb) {
    return `0.4rem ${props.isMwebSrp ? '0.2rem' : '0.6rem'}`;
  } else if (props.isCarousel) {
    return '0.6rem 0.4rem';
  } else {
    return '0.6rem 0.9rem';
  }
};

export const LikeAStarTagContainer = styled.div`
  border: 1px solid rgba(70, 72, 77, 0.2);
  border-radius: 4px;
  background: ${props => props.theme.colors.goWhite.base};
  color: ${props => props.theme.colors.downriver.dark};
  padding: ${props => likeAStarPaddingCalc(props)};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${props => props.margin || '0'};
  ${props => (props.isMweb || props.isCarousel ? textSizes.SmallW1 : textSizes.BaseW1)};
`;

export const HotelTag = styled.div`
  display: flex;
  align-items: center;
  padding: 0.2rem 0.4rem;
  border: 0.1rem solid #e4e4e4;
  ${textSizes.SmallW1};
  color: #222;
  border-radius: 0.4rem;
`;
